export const pesticides = [
        {
         category: 'Fungicidi',
         text: 'Cene fungicida',
         config: 'pesticidesFun',
         subcategories:[
            {
                name: 'Cena Akord (tebukonazol) fungicida',
                text: 'Cena Akord tebukonazol fungicida'
            },
            {
                name: 'Cena Captan WP 50 (kaptan) fungicida',
                text: 'Cena Captan WP 50 kaptan fungicida'
            },{
                name: 'Cena Bakarni oksihlorid fungicida',
                text: 'Cena Bakarni oksihlorid fungicida'
            },{
                name: 'Cena Chorus 75 WG fungicida',
                text: 'Cena Chorus 75 WG fungicida'
            },{
                name: 'Cena Dithane DG/neotec fungicida',
                text: 'Cena Dithane DG neotec fungicida'
            },{
                name: 'Cena Everest fungicida',
                text: 'Cena Everest fungicida'
            },{
                name: 'Cena Funguran OH fungicida',
                text: 'Cena Funguran OH kaptan fungicida'
            },{
                name: 'Cena Galofungin 500-SC (karbendazim) fungicida',
                text: 'Cena Galofungin 500 SC karbendazim fungicida'
            },{
                name: 'Cena Kumulus DF (sumpor) fungicida',
                text: 'Cena Kumulus DF sumpor fungicida'
            },{
                name: 'Cena Mankosav 80 wp fungicida',
                text: 'Cena Mankosav 80 wp fungicida'
            },{
                name: 'Cena Mankogal-80 (mankozeb) fungicida',
                text: 'Cena Mankogal 80 mankozeb fungicida'
            },{
                name: 'Cena Merpan 80 wdg fungicida',
                text: 'Cena Merpan 80 wdg fungicida'
            },{
                name: 'Cena Mikal fles ( Fosetl aluminijum+ folpet) fungicida',
                text: 'Cena Mikal fles Fosetl aluminijum folpet fungicida'
            },{
                name: 'Cena Polyram DF (metiram gold fungicida',
                text: 'Cena Polyram DF metiram gold fungicida'
            },{
                name: 'Cena Previcur Energy fungicida',
                text: 'Cena Previcur Energy fungicida'
            },{
                name: 'Cena Qvadris fungicida',
                text: 'Cena Qvadris fungicida'
            },{
                name: 'Cena Ridomil gold MZ 68 WG fungicida',
                text: 'Cena Ridomil gold MZ 68 WG fungicida'
            },{
                name: 'Cena Signum fungicida',
                text: 'Cena Signum fungicida'
            },{
                name: 'Cena Switch fungicida',
                text: 'Cena Switch fungicida'
            },{
                name: 'Cena Teldor ( fenheksamid )',
                text: 'Cena Teldor fenheksamid'
            },{
                name: 'Cena Topas 100 EC fungicida',
                text: 'Cena Topas 100 EC fungicida'
            },{
                name: 'Cena Zato 50-WG (trifloksistrobin) fungicida',
                text: 'Cena Zato 50-WG trifloksistrobin fungicida'
             },
             //{
            //     name: 'Cena Previcur Energy fungicida',
            //     text: 'Cena Previcur Energy fungicida'
            // },{
            //     name: 'Cena Promix (prosimidon) fungicida',
            //     text: 'Cena Promix prosimidon fungicida'
            // },{
            //     name: 'Cena Funguran OH fungicida',
            //     text: 'Cena Funguran OH fungicida'
            // },{
            //     name: 'Cena Qvadris fungicida',
            //     text: 'Cena Qvadris fungicida'
            // },{
            //     name: 'Cena Ridomil gold MZ 68 WG',
            //     text: 'Cena Ridomil gold MZ 68 WG fungicida'
            // },{
            //     name: 'Cena Ronilan DF fungicida',
            //     text: 'Cena Ronilan DF fungicida'
            // },{
            //     name: 'Cena Sabithane (dinokap+miklobutanil) fungicida',
            //     text: 'Cena Sabithane dinokap miklobutanil fungicida'
            // },{
            //     name: 'Cena Sabithane (dinokap+mikrobutanil) fungicida',
            //     text: 'Cena Sabithane dinokap mikrobutanil fungicida'
            // },{
            //     name: 'Cena Signum fungicida',
            //     text: 'Cena Signum fungicida'
            // },{
            //     name: 'Cena Sphere (trifloksistrobin + ciprokonazol) fungicida',
            //     text: 'Cena Sphere trifloksistrobin ciprokonazol fungicida'
            // },{
            //     name: 'Cena Strobi DS fungicida',
            //     text: 'Cena Strobi DS fungicida'
            // },{
            //     name: 'Cena Stroby DS fungicida',
            //     text: 'Cena Stroby DS fungicida'
            // },{
            //     name: 'Cena Switch fungicida',
            //     text: 'Cena Switch fungicida'
            // },{
            //     name: 'Cena Teldor (fenheksamid) fungicida',
            //     text: 'Cena Teldor fenheksamid fungicida'
            // },{
            //     name: 'Cena Topas 100 EC fungicida',
            //     text: 'Cena Topas 100 EC fungicida'
            // },{
            //     name: 'Cena Zanat fungicida',
            //     text: 'Cena Zanat fungicida'
            // },{
            //     name: 'Cena Zato 50-WG (trifloksistrobin) fungicida',
            //     text: 'Cena Zato 50 WG trifloksistrobin fungicida'
            // } 
         ]
        },
        {
         category: 'Herbicidi',
         text: 'Cene herbicida',
         config: 'pesticidesHer',
         subcategories:[
            {
                name: 'Cena Adengo herbicida',
                text: 'Cena Adengo dihlormid herbicida'
            },{
                name: 'Cena Basara herbicida',
                text: 'Cena Basara herbicida'
            },{
                name: 'Cena CORUM herbicida',
                text: 'Cena CORUM herbicida'
            },{
                name: 'Cena Dual gold 960-EC (S-metolahlor) herbicida',
                text: 'Cena Dual gold 960 EC S metolahlor herbicida'
            },{
                name: 'Cena Equip (foramsulfuron + izoksadifen-etil) herbicida',
                text: 'Cena Equip foramsulfuron izoksadifen etil herbicida'
            },{
                name: 'Cena Focus ultra (cikloksidim) herbicida',
                text: 'Cena Focus ultra cikloksidim herbicida'
            },{
                name: 'Cena Fusilade forte (fluazifop-P-butil) herbicida',
                text: 'Cena Fusilade forte fluazifop P butil herbicida'
            },{
                name: 'Cena Garlon 3-A (triklopir trietilamonijum) herbicida',
                text: 'Cena Garlon 3 A triklopir trietilamonijum herbicida'
            },{
                name: 'Cena Glifol (glifosat) herbicida',
                text: 'Cena Glifol glifosat herbicida'
            },{
                name: 'Cena Glifosav-480 (glifosat) herbicida',
                text: 'Cena Glifosav 480 glifosat herbicida'
            },{
                name: 'Cena Laudis (tembotrione) herbicida',
                text: 'Cena Laudis tembotrione herbicida'
            },{
                name: 'Cena Maton (2,4-D 2EH) herbicida',
                text: 'Cena Maton 2 4 D 2EH herbicida'
            },{
                name: 'Cena Deltacet plus herbicida',
                text: 'Cena Deltacet plus herbicida'
            },{
                name: 'Cena Merlin Flexx herbicida',
                text: 'Cena Merlin Flexx herbicida'
            },{
                name: 'Cena Meteor (metsulfuron-metil) herbicida',
                text: 'Cena Meteor metsulfuron metil herbicida'
            },{
                name: 'Cena Metmark herbicida',
                text: 'Cena Metmark herbicida'
            },{
                name: 'Cena Monosan herbi (2,4-D DMA) herbicida',
                text: 'Cena Monosan herbi 2 4 D DMA herbicida'
            },{
                name: 'Cena Nikon herbicida',
                text: 'Cena Nikon herbicida'
            },{
                name: 'Cena Nicogan herbicida',
                text: 'Cena Nicogan herbicida'
            },{
                name: 'Cena Pantera 40 EC (quizalofop-P-tefuril) herbicida',
                text: 'Cena Pantera 40 EC quizalofop P tefuril herbicida'
            },{
                name: 'Cena Peak 75 WG herbicida',
                text: 'Cena Peak 75 WG herbicida'
            },{
                name: 'Cena Plamen (dikamba) herbicida',
                text: 'Cena Plamen dikamba herbicida'
            },{
                name: 'Cena Rezon herbicida',
                text: 'Cena Rezon herbicida'
            },{
                name: 'Cena Sekator herbicida',
                text: 'Cena Sekator herbicida' 
            },{
                name: 'Cena Sencor WP 70 (metribuzin) herbicida',
                text: 'Cena Sencor WP 70 metribuzin herbicida'
            },{
                name: 'Cena Stomp aqua herbicida',
                text: 'Cena Stomp aqua herbicida'
            },{
                name: 'Cena Talisman (nikosulfuron) herbicida',
                text: 'Cena Talisman nikosulfuron herbicida'
            },{
                name: 'Cena Welton herbicida',
                text: 'Cena Welton herbicida'
             }
             //,{
            //     name: 'Cena Grid 75 WG herbicida',
            //     text: 'Cena Grid 75 WG herbicida'
            // },{
            //     name: 'Cena Guardian (acetohlor + AD-67) herbicida',
            //     text: 'Cena Guardian acetohlor AD 67 herbicida'
            // },{
            //     name: 'Cena Harmony 75 WG herbicida',
            //     text: 'Cena Harmony 75 WG herbicida'
            // },{
            //     name: 'Cena Herbocid (2,4-D DMA) herbicida',
            //     text: 'Cena Herbocid 2 4 D DMA herbicida'
            // },{
            //     name: 'Cena Laudis (tembotrione) herbicida',
            //     text: 'Cena Laudis (tembotrione) herbicida'
            // },{
            //     name: 'Cena Lontrel-100 (klopiralid) herbicida',
            //     text: 'Cena Lontrel 100 klopiralid herbicida'
            // },{
            //     name: 'Cena Lord 700-WDG  (metribuzin) herbicida',
            //     text: 'Cena Lord 700-WDG metribuzin herbicida'
            // },{
            //     name: 'Cena Maister-OD (foramsulfuron + izoksadifen-etil + jodosulfuron-metil-natrijum) herbicida',
            //     text: 'Cena Maister-OD foramsulfuron izoksadifen etil jodosulfuron metil natrijum herbicida'
            // },{
            //     name: 'Cena Maton (2,4-D 2EH) herbicida',
            //     text: 'Cena Maton 2 4 D 2EH herbicida'
            // },{
            //     name: 'Cena Merlin 750 WG (izoksaflutol) herbicida',
            //     text: 'Cena Merlin 750 WG izoksaflutol herbicida'
            // },{
            //     name: 'Cena Meteor (metsulfuron-metil) herbicida',
            //     text: 'Cena Meteor metsulfuron metil herbicida'
            // },{
            //     name: 'Cena Monosan herbi (2,4-D DMA) herbicida',
            //     text: 'Cena Monosan herbi 2 4 D DMA herbicida'
            // },{
            //     name: 'Cena Motivell (nikosulfuron) herbicida',
            //     text: 'Cena Motivell nikosulfuron herbicida'
            // },{
            //     name: 'Cena Moto (2,4 D EHE) herbicida',
            //     text: 'Cena Moto 2 4 D EHE herbicida'
            // },{
            //     name: 'Cena Nikon herbicida',
            //     text: 'Cena Nikon herbicida'
            // },{
            //     name: 'Cena Pantera 40 EC (quizalofop-P-tefuril) herbicida',
            //     text: 'Cena Pantera 40 EC quizalofop P tefuril herbicida'
            // },{
            //     name: 'Cena Peak 75 WG herbicida',
            //     text: 'Cena Peak 75 WG herbicida'
            // },{
            //     name: 'Cena Pivot M (imazetapir) herbicida',
            //     text: 'Cena Pivot M imazetapir herbicida'
            // },{
            //     name: 'Cena Plamen (dikamba) herbicida',
            //     text: 'Cena Plamen dikamba herbicida'
            // },{
            //     name: 'Cena Pulsar-40 (imazamox) herbicida',
            //     text: 'Cena Pulsar-40 imazamox herbicida'
            // },{
            //     name: 'Cena Reglone Forte (dikvat) herbicida',
            //     text: 'Cena Reglone Forte dikvat herbicida'
            // },{
            //     name: 'Cena Ritam (imazetapir) herbicida',
            //     text: 'Cena Ritam imazetapir herbicida'
            // },{
            //     name: 'Cena Sekator herbicida',
            //     text: 'Cena Sekator herbicida'
            // },{
            //     name: 'Cena Select super (kletodim) herbicida',
            //     text: 'Cena Select super kletodim herbicida'
            // },{
            //     name: 'Cena Sencor WP 70 (metribuzin) herbicida',
            //     text: 'Cena Sencor WP 70 metribuzin herbicida'
            // },{
            //     name: 'Cena Starane 250 (fluroksipir -meptil) herbicida',
            //     text: 'Cena Starane 250 fluroksipir meptil herbicida'
            // },{
            //     name: 'Cena Stockplus (fluroksipir-meptil-heptil) herbicida',
            //     text: 'Cena Stockplus fluroksipir meptil heptil herbicida'
            // },{
            //     name: 'Cena Stomp 330-E  (pendimetalin) herbicida',
            //     text: 'Cena Stomp 330 E pendimetalin herbicida'
            // },{
            //     name: 'Cena Talisman (nikosulfuron) herbicida',
            //     text: 'Cena Talisman nikosulfuron herbicida'
            // },{
            //     name: 'Cena Tarot 25-WG (rimsulfuron) herbicida',
            //     text: 'Cena Tarot 25 WG rimsulfuron herbicida'
            // },{
            //     name: 'Cena Triflurex 480 EC herbicida',
            //     text: 'Cena Triflurex 480 EC herbicida'
            // },{
            //     name: 'Cena Valsagard (acetohlor) herbicida',
            //     text: 'Cena Valsagard acetohlor herbicida'
            // },{
            //     name: 'Cena Vetpen 330-E herbicida',
            //     text: 'Cena Vetpen 330 E herbicida'
            // },{
            //     name: 'Cena Zanat (pendimetalin) herbicida',
            //     text: 'Cena Zanat pendimetalin herbicida'
            // } 
         ]

        },
        {
         category: 'Insekticidi',
         text: 'Cene insekticida',
         config: 'pesticidesIns',
         subcategories:[
            {
                name: 'Cena Actelic 50 insekticida',
                text: 'Cena Actelic 50 insekticida'
            }, {
                name: 'Cena Calypso 480-SC (tiakloprid) insekticida',
                text: 'Cena Calypso 480 SC tiakloprid insekticida'
            }, {
                name: 'Cena Confidor 200 SL (imidakloprid) insekticida',
                text: 'Cena Confidor 200 SL imidakloprid insekticida'
            }, {
                name: 'Cena Decis insekticida',
                text: 'Cena Decis insekticida'
            }, {
                name: 'Cena Exirel insekticida',
                text: 'Cena Exirel insekticida'
            }, {
                name: 'Cena SATURN TERRA insekticida',
                text: 'Cena SATURN TERRA insekticida'
            }, {
                name: 'Cena Force 1,5-G (teflutrin) insekticida',
                text: 'Cena Force 1 5 G teflutrin insekticida'
            }, {
                name: 'Cena Galmin insekticida',
                text: 'Cena Galmin insekticida'
            }, {
                name: 'Cena Mospilan 20 SP (acetamiprid) insekticida',
                text: 'Cena Mospilan 20 SP acetamiprid insekticida'
            }, {
                name: 'Cena Tonus (acetamiprid) insekticida',
                text: 'Cena Tonus acetamiprid insekticida'
            }, {
                name: 'Cena Vantex 60-SC (lambda cihalotrin) insekticida',
                text: 'Cena Vantex 60 SC lambda cihalotrin insekticida'
            }, {
                name: 'Cena Volley 20 SP (acetamiprid) insekticida',
                text: 'Cena Volley 20 SP acetamiprid insekticida'
            }, 
            // {
            //     name: 'Cena Etiol tečni (malation) insekticida',
            //     text: 'Cena Etiol tečni malation insekticida'
            // }, {
            //     name: 'Cena Fastac 10-EC (alfa-cipermetrin) insekticida',
            //     text: 'Cena Fastac 10 EC alfa cipermetrin insekticida'
            // }, {
            //     name: 'Cena Fenitrotion 50-EC (fenitrotion) insekticida',
            //     text: 'Cena Fenitrotion 50 EC fenitrotion insekticida'
            // }, {
            //     name: 'Cena Fobos (bifentrin) insekticida',
            //     text: 'Cena Fobos bifentrin insekticida'
            // },{
            //     name: 'Cena Foksim G-5 (foksim) insekticida',
            //     text: 'Cena Foksim G 5 foksim insekticida'
            // }, {
            //     name: 'Cena Force 1,5-G (teflutrin) insekticida',
            //     text: 'Cena Force 1 5 G teflutrin insekticida'
            // },  {
            //     name: 'Cena Furadan 35-ST (karbofuran) insekticida',
            //     text: 'Cena Furadan 35 ST karbofuran insekticida'
            // },  {
            //     name: 'Cena Fury 10-EC (zeta-cipermetrin) insekticida',
            //     text: 'Cena Fury 10 EC zeta cipermetrin insekticida'
            // },  {
            //     name: 'Cena Galition G-5 (fenitrotion + malation) insekticida',
            //     text: 'Cena Galition G 5 fenitrotion malation insekticida'
            // },  {
            //     name: 'Cena Galmin insekticida',
            //     text: 'Cena Galmin insekticida'
            // },  {
            //     name: 'Cena Insegar 25-WG (fenoksikarb) insekticida',
            //     text: 'Cena Insegar 25 WG fenoksikarb insekticida'
            // },  {
            //     name: 'Cena Kaiso (lambda-cihalotrin insekticida',
            //     text: 'Cena Kaiso lambda cihalotrin insekticida'
            // },  {
            //     name: 'Cena Karate zeon insekticida',
            //     text: 'Cena Karate zeon insekticida'
            // },  {
            //     name: 'Cena Konzul (hlorpirifos + cipermetrin) insekticida',
            //     text: 'Cena Konzul hlorpirifos cipermetrin insekticida'
            // }, {
            //     name: 'Cena Lanate25 WP (metomil) insekticida',
            //     text: 'Cena Lanate25 WP metomil insekticida'
            // },     {
            //     name: 'Cena Lebaycid EC-50  (fention ) insekticida',
            //     text: 'Cena Lebaycid EC 50 fention insekticida'
            // },     {
            //     name: 'Cena Match 050 EC insekticida',
            //     text: 'Cena Match 050 EC insekticida'
            // },     {
            //     name: 'Cena Megatrin 2,5 EC (lambda cihalotrin) insekticida',
            //     text: 'Cena Megatrin 2 5 EC lambda cihalotrin insekticida'
            // },     {
            //     name: 'Cena Mospilan 20 SP (acetamiprid) insekticida',
            //     text: 'Cena Mospilan 20 SP acetamiprid insekticida'
            // },     {
            //     name: 'Cena Nurell-D ( hlorpirifos + cipermetrin) insekticida',
            //     text: 'Cena Nurell D hlorpirifos cipermetrin insekticida'
            // },     {
            //     name: 'Cena Posse 25 EC (karbosulfan) insekticida',
            //     text: 'Cena Posse 25 EC karbosulfan insekticida'
            // },{
            //     name: 'Cena Regent 800 WG (fipronil) insekticida',
            //     text: 'Cena Regent 800 WG fipronil insekticida'
            // },{
            //     name: 'Cena Talstar 10-EC (bifentrin) insekticida',
            //     text: 'Cena Talstar 10 EC bifentrin insekticida'
            // }, {
            //     name: 'Cena Tonus (acetamiprid) insekticida',
            //     text: 'Cena Tonus acetamiprid insekticida'
            // }, {
            //     name: 'Cena Vantex 60-SC (lambda cihalotrin) insekticida',
            //     text: 'Cena Vantex 60 SC lambda cihalotrin insekticida'
            // }, {
            //     name: 'Cena Vertimec 018 EC (abamektin) insekticida',
            //     text: 'Cena Vertimec 018 EC abamektin insekticida'
            // }, {
            //     name: 'Cena Volley 20 SP (acetamiprid) insekticida',
            //     text: 'Cena Volley 20 SP acetamiprid insekticida'
            // }, {
            //     name: 'Cena Vydate-10 L (oxamil) insekticida',
            //     text: 'Cena Vydate 10 L oxamil insekticida'
            // }          
         ]

        }
    ]
